// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageAddItemWebView from 'xui/modules/storeWebsite/BaseUISalePageAddItemWebView'

export default class SalePageAddItemWebView extends BaseUISalePageAddItemWebView {}
